export default __webpack_public_path__ + "static/media/logo.bd374e54.svg";